document.addEventListener('DOMContentLoaded', function() {   
    $('.w-collection-slides-img').slick({
			slidesToShow: 3,
			slidesToScroll: 1,
			autoplay: true,
			autoplaySpeed: 5000,
			speed: 500,
			variableWidth: false,
			draggable: false,
			responsive: [{
				breakpoint: 1025,
				settings: {
					slidesToShow: 2,
				}
			   }, {
				breakpoint: 769,
				settings: {
					slidesToShow: 1,
					variableWidth: false,
					centerMode: false,
					//adaptiveHeight: true,
				}
			}]

		});
});